import { Component, OnInit } from '@angular/core';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';

@Component({
  selector: 'app-upi-list',
  templateUrl: './upi-list.component.html',
  styleUrls: ['./upi-list.component.scss']
})
export class UpiListComponent implements OnInit {
  filteredDetails:any = {
    name:'',
    payment_mode:''
  }
  getPaginationCount:any
  upilist:any = ''
  page:any = 1
  buttonflag:any = 0
  constructor(
    private apiService : ApiService,
    private apiConfig : ApiConfiguration,
    private toast : ToastClientService,
  ) { }

  ngOnInit() {
    this.getUpilist()
  }
  getUpilist(){
    this.apiService.getHeaders(this.apiConfig.Upilist + `?program_id=1&page=${this.page}&ro_code=${this.filteredDetails.name}&payment_mode=${this.filteredDetails.payment_mode}`).subscribe((res:any)=>{
      console.log(res)
      this.upilist = res.body.data
      this.getPaginationCount = res.headers.get('X-Pagination-Total-Count')
    })
  }

  optionChanged(){
    this.getUpilist()
  }

  filterListOfRecords(){
    this.getUpilist()
  }
  Reset(){
    this.filteredDetails.name = ''
    this.filteredDetails.payment_mode = ''
    this.getUpilist()
  }

  paginationClick(event){
    this.page = event
    this.getUpilist()
  }

  Approve(data){
    console.log(data)
    let payload = {
      id : data.id,
      user_id : data.user_id
    }
    console.log(payload)
    // this.getUpilist()

    this.apiService.post(this.apiConfig.Approve,payload).subscribe((res:any)=>{
      this.toast.Success(res.body.data.message)
      // this.buttonflag = 1
      this.getUpilist()

    })
  }
  Reject(data){
    console.log(data)
    let payload = {
      id : data.id,
      user_id : data.user_id
    }
    console.log(payload)

    // this.getUpilist()

    this.apiService.post(this.apiConfig.Reject,payload).subscribe((res:any)=>{
      this.toast.Success(res.body.data.message)
      // this.buttonflag = 1
      this.getUpilist()
    })
  }
}
